import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Priya Sharma',
      role: 'Product Designer',
      avatar: 'PS',
      content: 'Drivault has completely transformed how I manage my design files across devices. The sync is instant and the security features give me peace of mind.',
      rating: 5
    },
    {
      name: 'Rahul Mehta',
      role: 'Software Engineer',
      avatar: 'RM',
      content: 'Finally, a cloud storage solution that works seamlessly on Linux! The referral program is genius - I earned 500GB just by inviting my team.',
      rating: 5
    },
    {
      name: 'Anjali Patel',
      role: 'Content Creator',
      avatar: 'AP',
      content: 'The instant storage expansion saved my phone! I can now store all my videos without worrying about running out of space.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Loved By <span className="text-[#40E095]">10,000+</span> Users
          </h2>
          <p className="text-lg text-gray-600">
            See what our users have to say about their Drivault experience
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index}
              className="border-2 border-gray-100 hover:border-[#40E095]/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-2"
            >
              <CardContent className="p-6 space-y-4">
                {/* Quote Icon */}
                <Quote className="text-[#40E095]/20" size={40} />

                {/* Rating */}
                <div className="flex space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-[#40E095] fill-[#40E095]" size={16} />
                  ))}
                </div>

                {/* Content */}
                <p className="text-gray-700 leading-relaxed">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="flex items-center space-x-3 pt-4 border-t">
                  <Avatar className="bg-[#40E095] text-white">
                    <AvatarFallback>{testimonial.avatar}</AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="font-semibold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto mt-16">
          <div className="text-center">
            <p className="text-4xl font-bold text-[#40E095] mb-2">10K+</p>
            <p className="text-gray-600">Active Users</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-[#40E095] mb-2">5</p>
            <p className="text-gray-600">Platforms</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-[#40E095] mb-2">99.9%</p>
            <p className="text-gray-600">Uptime</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-[#40E095] mb-2">50M+</p>
            <p className="text-gray-600">Files Synced</p>
          </div>
        </div>

        {/* Social Proof Image */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c" 
              alt="Happy users" 
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
